<template>
<blockquote class="text-gray-200 font-heading font-light pl-6 border-l-4 border-current text-2xl md:text-3xl max-w-2xl my-4 mx-auto">
Want to be healthy and have a perfect body? BigBear is the right decision for you! It will create your personal training program and balance your diet so you could get the shape of your dream shortly!
</blockquote>
</template>

<script>
export default {

}
</script>

<style>

</style>